import React, { useState } from 'react'
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer'


function Works() {

    const { ref, inView } = useInView();
    const [filter, setFilter] = useState("all")
    const handleFilterClick = (item) => {
        setFilter(item);
    }

    useEffect(() => {
        if (inView) {

            if(inView){

                
                document.querySelectorAll(".work__item").forEach((item)=>{
                    item.style.transform = "translateY(0)"
                    item.style.opacity = 1
                })
                
            }
            
            
        } else {
            
            document.querySelectorAll(".work__item").forEach((item)=>{
                item.style.transform = "translateY(50px)"
                item.style.opacity = 0
            })
           

            
        }
    }, [inView])

    const [toggleState, setToggleState] = useState(0)

    const toggleTab = (index) => {
        document.getElementById("myVideo").pause()
        setToggleState(index)
    }

    return (
        <div ref={ref} >
            <div  className="work__filters">
                <span onClick={() => handleFilterClick("all")} className={filter === "all" ? "work__item active-work" : "work__item"}>All</span>
                <span style={{ "transitionDelay": "0.2s" }} onClick={() => handleFilterClick("fullstack")} className={filter === "fullstack" ? "work__item active-work" : "work__item"}>Fullstack</span>
                <span style={{ "transitionDelay": "0.4s" }} onClick={() => handleFilterClick("frontend")} className={filter === "frontend" ? "work__item active-work" : "work__item"}>Frontend</span>
                <span style={{ "transitionDelay": "0.6s" }} onClick={() => handleFilterClick("css")} className={filter === "css" ? "work__item active-work" : "work__item"}>CSS</span>
            </div>

            <div ref={ref} className={filter === "all" ? "work__container work__container__active container grid" : "work__container container grid"}>

                {/* all projects */}


                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_011108.png?alt=media&token=729c0fec-51b2-4e6b-8b9c-dee444faf0aa" alt="work" className='work__img' />
                    <h3 className="work__title">Amazone Clone</h3>
                    <p onClick={() => toggleTab(1)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Amazone Clone</h3>


                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/amazone%20clone.webm?alt=media&token=a2e479fc-ad79-4da0-8486-86fc9004d3e7" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    <p>
                                        An amazone clone project made with the MERN stack.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React JS , Express JS , Mongo DB , Firebase.</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/amazon-clone" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_125334.png?alt=media&token=4fe02f86-ea49-46c5-9910-50ea6da8bcf2" alt="work" className='work__img' />
                    <h3 className="work__title">Rentify</h3>
                    <p onClick={() => toggleTab(2)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Rentify</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/screen-capture%20(39).webm?alt=media&token=b89f6aad-a835-41f3-b438-a7d312d64abb" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A  react full stack project where you will be provided with properties to rent based on the seraching filters provided at the top.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React js , Express JS , Mongo DB , Node js</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/reunion" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                {/* frrontend projects */}

                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_010839.png?alt=media&token=ec88770d-966d-4462-bca7-34658c6f4d3a" alt="work" className='work__img' />
                    <h3 className="work__title">React Admin Dashboard</h3>
                    <p onClick={() => toggleTab(4)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 4 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">React Admin Dashboard</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/admin%20dashboard.webm?alt=media&token=c66cc993-ac45-41dc-a353-0e35ac57afd0" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        An admin panel that you can use in you e-commerece app to view the performance/analytics of your app.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React js , Recharts</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/react-admit-dashboard.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_010854.png?alt=media&token=5cc2b448-2201-45fc-8968-730d71431d49" alt="work" className='work__img' />
                    <h3 className="work__title">NFT collection</h3>
                    <p onClick={() => toggleTab(5)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 5 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">NFT collection</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/nft%20website.webm?alt=media&token=46ff79d7-3fb9-4413-9614-6b6351ae07d8" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A website where you can list you NFT's
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React JS </span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/the-classics.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_011144.png?alt=media&token=045033ba-a0c3-4739-b6e2-481289ee3f27" alt="work" className='work__img' />
                    <h3 className="work__title">NewsKeeda</h3>
                    <p onClick={() => toggleTab(6)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 6 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">NewsKeeda</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/news%20keeda.webm?alt=media&token=73824f56-0751-48eb-ac4c-3aba31d94e81" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A frontend project that can fetch latest news for you.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css , Javascipt</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/newskeeda.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


                {/* css */}

                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123648.png?alt=media&token=8d7bdf02-9cf7-4d94-bb9e-f94309bd92ca" alt="work" className='work__img' />
                    <h3 className="work__title">Animated Toggle Menu</h3>
                    <p onClick={() => toggleTab(8)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 8 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Animated Toggle Menu</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/animated%20toggle%20menu%20button.webm?alt=media&token=9e9096f7-22a9-40c1-8699-95ab79d29d6d" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple toggle menu animation with css
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">HTML , CSS</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/animated_toggle_menu_button" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123810.png?alt=media&token=30df0324-c554-45b6-984d-21a4457f29df" alt="work" className='work__img' />
                    <h3 className="work__title">Navbar Circle</h3>
                    <p onClick={() => toggleTab(9)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 9 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Navbar Circle</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/circle%20up%20animation.webm?alt=media&token=be8b1266-1434-44ba-a636-e21caacef018" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple navbar animation where the items in the nav will get animated as soon as you hover upon them.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/circleup-animation" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123939.png?alt=media&token=a342c85b-36a5-4434-adab-91b2f09a77c0" alt="work" className='work__img' />
                    <h3 className="work__title">TypeWriter CSS effect</h3>
                    <p onClick={() => toggleTab(10)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 10 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">TypeWriter CSS effect</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/typre%20writer%20effect%20css.webm?alt=media&token=3cabf3a7-49f9-45dd-aea7-fcdd8b5c2c61" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A typerwriter css effect where some words are dislayed in the form of characters.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">demo</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/typerwriter-effect-css" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_124102.png?alt=media&token=35a6662c-d3d1-43ca-86c7-2569de48dd3a" alt="work" className='work__img' />
                    <h3 className="work__title">Wavy Text animation</h3>
                    <p onClick={() => toggleTab(11)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 11 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Wavy Text animation</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/wavy%20text%20animation.webm?alt=media&token=f3cca00b-0905-4e11-b10a-357b6e9b3971" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        An css animation where the text is displayed in wave form.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/wavy-text-animation" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123449.png?alt=media&token=4635f2a9-8297-4089-adb7-11d548e05a09" alt="work" className='work__img' />
                    <h3 className="work__title">Bubble Animation</h3>
                    <p onClick={() => toggleTab(12)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 12 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Bubble Animation</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/bubble%20animation.webm?alt=media&token=4ea87cb6-8340-4a64-a697-b521edf8ca8b" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple css animation in which the letters fall from a certain height in some delayed seconds.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/bubble-website" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


            </div>


            {/* sectional view starts  */}


            <div ref={ref} className={filter === "fullstack" ? "work__container work__container__active container grid" : "work__container container grid"}>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_011108.png?alt=media&token=729c0fec-51b2-4e6b-8b9c-dee444faf0aa" alt="work" className='work__img' />
                    <h3 className="work__title">Amazone Clone</h3>
                    <p onClick={() => toggleTab(1)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Amazone Clone</h3>


                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/amazone%20clone.webm?alt=media&token=a2e479fc-ad79-4da0-8486-86fc9004d3e7" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    <p>
                                        An amazone clone project made with the MERN stack.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React JS , Express JS , Mongo DB , Firebase.</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/amazon-clone" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_125334.png?alt=media&token=4fe02f86-ea49-46c5-9910-50ea6da8bcf2" alt="work" className='work__img' />
                    <h3 className="work__title">Rentify</h3>
                    <p onClick={() => toggleTab(2)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Rentify</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/screen-capture%20(39).webm?alt=media&token=b89f6aad-a835-41f3-b438-a7d312d64abb" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A  react full stack project where you will be provided with properties to rent based on the seraching filters provided at the top.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React js , Express JS , Mongo DB , Node js</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/reunion" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </div>

            <div ref={ref} className={filter === "frontend" ? "work__container work__container__active container grid" : "work__container container grid"}>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_010839.png?alt=media&token=ec88770d-966d-4462-bca7-34658c6f4d3a" alt="work" className='work__img' />
                    <h3 className="work__title">React Admin Dashboard</h3>
                    <p onClick={() => toggleTab(4)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 4 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">React Admin Dashboard</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/admin%20dashboard.webm?alt=media&token=c66cc993-ac45-41dc-a353-0e35ac57afd0" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        An admin panel that you can use in you e-commerece app to view the performance/analytics of your app.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React js , Recharts</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/react-admit-dashboard.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_010854.png?alt=media&token=5cc2b448-2201-45fc-8968-730d71431d49" alt="work" className='work__img' />
                    <h3 className="work__title">NFT collection</h3>
                    <p onClick={() => toggleTab(5)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 5 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">NFT collection</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/nft%20website.webm?alt=media&token=46ff79d7-3fb9-4413-9614-6b6351ae07d8" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A website where you can list you NFT's
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">React JS </span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/the-classics.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_011144.png?alt=media&token=045033ba-a0c3-4739-b6e2-481289ee3f27" alt="work" className='work__img' />
                    <h3 className="work__title">NewsKeeda</h3>
                    <p onClick={() => toggleTab(6)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 6 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">NewsKeeda</h3>

                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/news%20keeda.webm?alt=media&token=73824f56-0751-48eb-ac4c-3aba31d94e81" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A frontend project that can fetch latest news for you.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css , Javascipt</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/newskeeda.git" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>


            </div>
            <div ref={ref} className={filter === "css" ? "work__container work__container__active container grid" : "work__container container grid"}>

                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123648.png?alt=media&token=8d7bdf02-9cf7-4d94-bb9e-f94309bd92ca" alt="work" className='work__img' />
                    <h3 className="work__title">Animated Toggle Menu</h3>
                    <p onClick={() => toggleTab(8)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 8 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Animated Toggle Menu</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/animated%20toggle%20menu%20button.webm?alt=media&token=9e9096f7-22a9-40c1-8699-95ab79d29d6d" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple toggle menu animation with css
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">HTML , CSS</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/animated_toggle_menu_button" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123810.png?alt=media&token=30df0324-c554-45b6-984d-21a4457f29df" alt="work" className='work__img' />
                    <h3 className="work__title">Navbar Circle</h3>
                    <p onClick={() => toggleTab(9)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 9 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Navbar Circle</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/circle%20up%20animation.webm?alt=media&token=be8b1266-1434-44ba-a636-e21caacef018" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple navbar animation where the items in the nav will get animated as soon as you hover upon them.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/circleup-animation" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123939.png?alt=media&token=a342c85b-36a5-4434-adab-91b2f09a77c0" alt="work" className='work__img' />
                    <h3 className="work__title">TypeWriter CSS effect</h3>
                    <p onClick={() => toggleTab(10)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 10 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">TypeWriter CSS effect</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/typre%20writer%20effect%20css.webm?alt=media&token=3cabf3a7-49f9-45dd-aea7-fcdd8b5c2c61" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A typerwriter css effect where some words are dislayed in the form of characters.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">demo</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/typerwriter-effect-css" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_124102.png?alt=media&token=35a6662c-d3d1-43ca-86c7-2569de48dd3a" alt="work" className='work__img' />
                    <h3 className="work__title">Wavy Text animation</h3>
                    <p onClick={() => toggleTab(11)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 11 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Wavy Text animation</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/wavy%20text%20animation.webm?alt=media&token=f3cca00b-0905-4e11-b10a-357b6e9b3971" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        An css animation where the text is displayed in wave form.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/wavy-text-animation" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="work__card">
                    <img src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/Screenshot_20221207_123449.png?alt=media&token=4635f2a9-8297-4089-adb7-11d548e05a09" alt="work" className='work__img' />
                    <h3 className="work__title">Bubble Animation</h3>
                    <p onClick={() => toggleTab(12)} className="work__button">
                        More <i className="bx bx-right-arrow-alt work__button-icon"></i>
                    </p>

                    <div className={toggleState === 12 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Bubble Animation</h3>
                            <div className="work__modal__content">
                                <video src="https://firebasestorage.googleapis.com/v0/b/manas-upadhyay.appspot.com/o/bubble%20animation.webm?alt=media&token=4ea87cb6-8340-4a64-a697-b521edf8ca8b" controls className="work__modal__content__video" id='myVideo'></video>
                                <div className="work__modal__content__about">
                                    {/*  <h3 className="work__modal__title">About  the project</h3>*/}
                                    <p>
                                        A simple css animation in which the letters fall from a certain height in some delayed seconds.
                                    </p>
                                </div>
                                <div className="work__modal__links">
                                    <h3 className="work__technologies">Technologies Used:   </h3>
                                    <span className="work__technologies__used">Html , Css</span>
                                    <h3 className="work__modal__code__link"> Code link: <a style={{ "textDecoration ": " none " }} href="https://github.com/ManasUpadhyay13/bubble-website" target="__blank"> <i className="uil uil-github-alt"></i></a> </h3>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Works

